import type { IRandomAccessDataSource } from "@colibrio/colibrio-reader-framework/colibrio-core-io-base";

export const useCirrusHttpDataSource = (size: number = 0, user?: string, sessionToken?: string): IRandomAccessDataSource => {
    const CirrusReaderHttpRequest = useCirrusReaderHttpRequest(user, sessionToken);
    
    const fetchChunk = async (startOffset: number, endOffset: number): Promise<ArrayBuffer> => {
        return CirrusReaderHttpRequest.sendRangeRequest(startOffset, endOffset - 1, size).catch(async (err) => {
            throw Promise.reject("An unknown error has occurred - " + err.toString());
        });
    }
    
    const getSize = (): number => {
        return size;
    }

    return {
        fetchChunk,
        getSize
    }
}